<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import JoditVue from '@components/jodit/jodit-vue'
import SchoolClassApi from '@api/school/classes'

export default {
  page: {
    title: 'Třídy: Nová třída',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, JoditVue },
  data() {
    return {
      form: {
        name: '',
        startYear: null,
        endYear: null,
      },
    }
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.id = this.$route.params.id
      this.editMode = this.id !== undefined

      if (this.editMode) {
        SchoolClassApi.get(this.id)
          .then((response) => {
            this.form = response.data.result
          })
          .catch((e) => {
            console.error(e)
            this.$swal({
              title: this.L('base_result_Error'),
              text: this.L('base_info_loaditem_error'),
              type: 'error',
            })
            this.$router.push({ name: 'settingClasses' })
          })
          .finally(() => {
            this.init = true
          })
      }
    },
    onSubmit() {
      this.$validator.validateAll().then((result) => {
        if (!result) return

        let formData = Object.assign({}, this.form);

        SchoolClassApi.createEdit(formData)
          .then(() => {
            this.$toasted.success('Třída byla úspěšně uložena!', {
              theme: 'toasted-primary',
              position: 'bottom-right',
              duration: 5000,
            })
            this.$router.push({ name: 'settingClasses' })
          })
          .catch((e) => {
            console.error(e)
            this.$swal({
              title: 'Nastala chyba',
              text: 'Nepodařlo se uložit třídu!',
              type: 'error',
            })
          })
          .finally(() => {})
      })
    },
    onReset() {},
  },
}
</script>

<template>
  <Layout>
    <div slot="heading">
      <h1>Třídy</h1>
      <router-link :to="{ name: 'settingClasses' }" class="btn btn-second">
        zpět na seznam
      </router-link>
    </div>
    <div slot="tools">
      <b-button @click.prevent="onSubmit" class="btn btn-first">
        <font-awesome-icon :icon="['fas', 'save']" class="icon alt"/>Uložit
      </b-button>
    </div>

    <div class="page-content">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h2 class="pillar-title">Nová třída</h2>

            <div class="card md-card">
              <div class="card-body">
                <b-form @submit.prevent="onSubmit" @reset="onReset">

                    <b-form-group
                        class="required"
                        label="Název třídy"
                        label-for="class-name"
                        description="Url adresa: www.skola.cz/artilce/titulek-clanku"
                    >
                        <b-form-input
                        id="class-name"
                        v-model="form.name"
                        type="text"
                        required
                        placeholder="A,B,C..."
                        >
                        </b-form-input>
                    </b-form-group>


                    <b-form-group label="Začátek studia:" label-for="classStartYear">
                        <div :class="{'is-invalid' : errors.has('publisclassStartYearhedOn')}">
                            <b-form-input type="number" name="classStartYear" id="classStartYear" v-model="form.startYear" />
                        </div>
                        <div
                        v-show="errors.has('classStartYear')"
                        class="invalid-feedback"
                        >{{ errors.first('classStartYear') }}</div>
                    </b-form-group>

                    <b-form-group label="Konec studia:" label-for="classEndYear">
                        <div :class="{'is-invalid' : errors.has('classEndYear')}">
                            <b-form-input type="number" name="classEndYear" id="classEndYear" v-model="form.endYear" />
                        </div>
                        <div
                        v-show="errors.has('classEndYear')"
                        class="invalid-feedback"
                        >{{ errors.first('classEndYear') }}</div>
                    </b-form-group>


                  <b-button type="submit" variant="primary">Uložit</b-button>
                </b-form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
